import type { Language } from '@/contexts/LanguageContext';
import type { Company, JobPosition, JobPosting } from '@/types';

/** Candidate-facing locale: posting → position → company default → English. */
export function resolveCandidateLocale(
  posting: JobPosting | null | undefined,
  position: JobPosition | null | undefined,
  company: Company | null | undefined,
): Language {
  if (posting?.outputLanguage === 'en' || posting?.outputLanguage === 'it') {
    return posting.outputLanguage;
  }
  if (position?.outputLanguage === 'en' || position?.outputLanguage === 'it') {
    return position.outputLanguage;
  }
  if (company?.defaultOutputLanguage === 'en' || company?.defaultOutputLanguage === 'it') {
    return company.defaultOutputLanguage;
  }
  return 'en';
}
